<template>
  <router-view />
</template>

<script>
// import { mapGetters } from 'vuex';

export default {
  name: 'App',
  // data() {
  //   return {};
  // },
  // computed: {
  //   ...mapGetters('auth', ['isAuthenticated']),
  // },
};
</script>
